// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| CONTABLE MENU ITEMS ||============================== //

const contable = {
    id: 'contable',
    title: 'Contabilidad',
    type: 'group',
    children: [
        {
            id: 'tipos_companias',
            title: 'Tipos de compañías',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'lista_tipos_companias',
                    title: 'Lista tipos compañías',
                    type: 'item',
                    url: '/superadmin/list-type-company'
                },
                {
                    id: 'nuevo_tipo_compania',
                    title: 'Nuevo Tipo de compañía',
                    type: 'item',
                    url: '/superadmin/new-type-company/0'
                },                
            ]
        },
        {
            id: 'estados_financieros',
            title: 'Estados Financieros',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'lista_estados_financieros',
                    title: 'Lista Estados Financieros',
                    type: 'item',
                    url: '/superadmin/list-estados-financieros'
                },
                {
                    id: 'nuevo_estado_financiero',
                    title: 'Nuevo Estado Financiero',
                    type: 'item',
                    url: '/superadmin/new-estados-financieros/0'
                },                
            ]
        },
        {
            id: 'cuentas_contables',
            title: 'Cuentas Contables',
            type: 'collapse',
            icon: icons.IconBasket,
            children: [
                {
                    id: 'nueva_cuenta_clase_1',
                    title: 'Cuenta Clase 1',
                    type: 'item',
                    url: '/superadmin/new-account-class1/0',
                    breadcrumbs: false
                },
                {
                    id: 'list_cuenta_clase_1',
                    title: 'Lista Cuenta 1',
                    type: 'item',
                    url: '/superadmin/list-account-class1',
                    breadcrumbs: false
                },                
                {
                    id: 'nueva_cuenta_clase_2',
                    title: 'Cuenta Clase 2',
                    type: 'item',
                    url: '/superadmin/new-account-class2/0',
                    breadcrumbs: false
                },
                {
                    id: 'list_cuenta_clase_2',
                    title: 'Lista Cuenta 2',
                    type: 'item',
                    url: '/superadmin/list-account-class2',
                    breadcrumbs: false
                },                
                {
                    id: 'nueva_cuenta_clase_3',
                    title: 'Cuenta Clase 3',
                    type: 'item',
                    url: '/superadmin/new-account-class3/0',
                    breadcrumbs: false
                },
                {
                    id: 'list_cuenta_clase_3',
                    title: 'Lista Cuenta 3',
                    type: 'item',
                    url: '/superadmin/list-account-class3',
                    breadcrumbs: false
                },                
                {
                    id: 'nueva_cuenta_clase_4',
                    title: 'Cuenta Clase 4',
                    type: 'item',
                    url: '/superadmin/new-account-class4/0',
                    breadcrumbs: false
                },
                {
                    id: 'list_cuenta_clase_4',
                    title: 'Lista Cuenta 4',
                    type: 'item',
                    url: '/superadmin/list-account-class4',
                    breadcrumbs: false
                },
                {
                    id: 'nueva_cuenta_clase_5',
                    title: 'Cuenta Clase 5',
                    type: 'item',
                    url: '/superadmin/new-account-class5/0',
                    breadcrumbs: false
                },
                {
                    id: 'list_cuenta_clase_5',
                    title: 'Lista Cuenta 5',
                    type: 'item',
                    url: '/superadmin/list-account-class5',
                    breadcrumbs: false
                },
            ]
        },
    ]
};

export default contable;
